import { useEffect, useReducer } from 'react';
import { PageWatchProps } from './PageWatch';

type SubmitAction = { type: 'sending' };
export const submitted = (): SubmitAction => ({ type: 'sending' });

type InitialAction = {
  type: 'initial';
  data: PageWatchProps;
};

type SuccessAction = {
  type: 'success';
  response: PageWatchProps;
};
export const succeded = (response: PageWatchProps): SuccessAction => ({
  type: 'success',
  response,
});

type FailAction = { type: 'fail'; error: string };
export const failed = (error: string): FailAction => ({ type: 'fail', error });

type ActionStateSuccess = {
  type: 'success';
  response: PageWatchProps;
};
type ActionStateSubmit = {
  type: 'sending';
};
type ActionStateFailure = {
  type: 'fail';
  error: string;
};
type ActionStateInitial = {
  type: 'initial';
};
export type ActionState = ActionStateInitial | ActionStateSubmit | ActionStateSuccess | ActionStateFailure;

type PageWatchActionState = { actionState: ActionState; data: PageWatchProps };
function reducer(
  s: PageWatchActionState,
  action: InitialAction | SubmitAction | FailAction | SuccessAction,
): PageWatchActionState {
  switch (action.type) {
    case 'initial':
      return { actionState: action, data: action.data };
    case 'sending':
      return { ...s, actionState: action };
    case 'success':
      return { actionState: action, data: action.response };
    case 'fail':
      return { ...s, actionState: action };
    default:
      return s;
  }
}

export function usePageWatchUpdate(initialState: PageWatchProps) {
  const [state, dispatch] = useReducer(reducer, {
    actionState: { type: 'initial' },
    data: initialState,
  });

  /**
   * If the user removes watched page by watched page list, that causes to
   * refetch of the data. Since useReducer does not recognize new changes,
   * we update the state by dispatching new the changes
   * */
  useEffect(() => {
    dispatch({
      type: 'initial',
      data: initialState,
    });
  }, [initialState]);

  return { dispatch, ...state };
}

export type DispatchFunction = ReturnType<typeof usePageWatchUpdate>['dispatch'];
